import React, { memo, ReactNode } from 'react';
import { Grid, Typography, Divider, Box } from '@material-ui/core';
import { useCampfireTheme } from '../theme/useCampfireTheme';

const FormSectionV2 = memo(
  ({
    title,
    search,
    description,
    children,
  }: {
    title: string;
    search?: ReactNode;
    children: ReactNode;
    description?: ReactNode;
  }) => {
    const { isMobile, isSm } = useCampfireTheme();
    return (
      <Grid item container xs={12} style={{ padding: isMobile ? 0 : 16 }} spacing={2} justify='space-between'>
        <Grid item container sm={5} xs={12} direction='row' justify-content='space-between' alignItems='flex-start'>
          <Box display={isSm ? 'block' : 'flex'} justifyContent='space-between' alignItems='center' width='100%'>
            <Box>
              <Typography style={{ fontSize: 15, fontWeight: 600, color: '#333', marginBottom: 4 }}>{title}</Typography>
              <Box style={{ fontSize: 13, color: '#808080', lineHeight: 1.5 }}>{description}</Box>
            </Box>
            {search && (
              <Box
                display={isSm ? 'block' : 'flex'}
                justifyContent='flex-end'
                alignItems='flex-end'
                pl={isSm ? 0 : '4px'}
              >
                {search}
              </Box>
            )}
          </Box>
        </Grid>
        <Grid item sm={7} xs={12}>
          {children}
        </Grid>
        <Grid item xs={12} style={{ paddingTop: isMobile ? 12 : 6, paddingBottom: isMobile ? 12 : 6 }}>
          <Divider style={{ backgroundColor: '#EFEFEF' }} />
        </Grid>
      </Grid>
    );
  }
);

export { FormSectionV2 };
